export default [{
    id: 'JMPB001',
    name: 'B 区一期项目01',
    status: '已建成',
    year: '2016',
    cost: '283万元',
    progress: 100,
    lng: 118.04401078393822,
    lat: 24.6144765432241,
}, {
    id: 'JMPB002',
    name: 'B 区一期项目02',
    status: '已建成',
    year: '2016',
    cost: '203万元',
    progress: 100,
    lng: 118.0421049360058,
    lat: 24.613361607366596,
}, {
    id: 'JMPB003',
    name: 'B 区三期项目01',
    status: '在建',
    year: '2022',
    cost: '323万元',
    progress: 10,
    lng: 118.04272365322383,
    lat: 24.616085616681648,
}, {
    id: 'JMPB004',
    name: 'B 区三期项目02',
    status: '待建',
    year: '2025',
    cost: '343万元',
    progress: 0,
    lng: 118.04107671930576,
    lat: 24.61479283552073,
}, {
    id: 'JMPB005',
    name: 'B 区二期项目01',
    status: '已建成',
    year: '2017',
    cost: '673万元',
    progress: 100,
    lng: 118.03948839979837,
    lat: 24.61676736890374,
}, {
    id: 'JMPB006',
    name: 'B 区二期项目02',
    status: '已建成',
    year: '2017',
    cost: '443万元',
    progress: 100,
    lng: 118.03785065082737,
    lat: 24.618300976935927,
}, {
    id: 'JMPB007',
    name: 'B 区二期项目03',
    status: '已建成',
    year: '2017',
    cost: '544万元',
    progress: 100,
    lng: 118.03987388774097,
    lat: 24.620046323492996,
}, {
    id: 'JMPB008',
    name: 'B 区二期项目04',
    status: '已建成',
    year: '2019',
    cost: '744万元',
    progress: 100,
    lng: 118.0409038283418,
    lat: 24.61787680773339,
}];